export const CALENDAR_DETAIL_CLOSE_EVENT = 'streamlain:calendar-detail-close';
export const CALENDAR_DETAIL_TARGET_EVENT = 'streamlain:calendar-detail-target';

export interface CalendarDetailTarget {
  detailOnly: boolean;
  occurrenceStart: string | null;
  rowId: string | null;
  viewId: string | null;
}

/** Planner keyboard requests use the mounted source editor's existing button workflow. */
export const CALENDAR_DETAIL_DELETE_EVENT = 'streamlain:calendar-detail-delete';
export interface CalendarDetailDeleteRequest {
  rowId: string;
  viewId: string;
  occurrenceStart: string | null;
  request?: Promise<void>;
}
export function requestCalendarDetailDelete(
  host: HTMLElement,
  target: Omit<CalendarDetailDeleteRequest, 'request'>
): Promise<void> {
  const detail: CalendarDetailDeleteRequest = { ...target };
  host.dispatchEvent(new CustomEvent(CALENDAR_DETAIL_DELETE_EVENT, { detail }));
  if (!detail.request)
    return Promise.reject(new Error('Calendar source editor unavailable'));
  return detail.request;
}
